import React from "react";
import {Row} from "react-bootstrap";
import NawCompaniesDetailsContactTable from "./NawCompaniesDetailContactTable";

export default function NawCompaniesDetailsContactTableHandler({companyContactPersons}) {
    //laat tabel zien met gegevens via props
    if (companyContactPersons.length > 0) return <NawCompaniesDetailsContactTable companyContactPersons={companyContactPersons}/>;
    else
        return (
            <Row className="justify-content-center align-self-center w-100 text-center">
                Geen contactpersonen van dit bedrijf gevonden.
            </Row>
        );
}

